<template>
  <div class="wh100">
    <div class="top-title">
      <div>
        <el-button type="primary" v-if="isShowClose" @click="close">
          关闭</el-button
        >
      </div>
      <div>
        <el-button type="warning" v-print="printobj">
          <i class="el-icon-printer"></i> 打印</el-button
        >
        <el-button type="success" @click="SubProjectInspect" v-if="isShowBut">
          <i class="el-icon-s-claim"></i> 完 成</el-button
        >
      </div>
    </div>
    <div class="content-info">
      <div class="left-info" v-if="isShowLeft">
        <el-card class="box-card">
          <div class="supplier-title">供应商列表</div>
          <div
            v-for="(item, index) in TaskSupplieData"
            :key="item.Id"
            @click="handleClick(item)"
            :class="['supplier-item', { active: item.Id === SupplierId }]"
          >
            <el-button :type="item.Id === SupplierId ? 'primary' : ''">{{
              item.cVenName
            }}</el-button>
          </div>
        </el-card>
      </div>
      <div class="content">
        <div id="print-info">
          <div class="a1 w100">
            <div class="title">
              <span>{{ ProjectInfo.Name || '' }}</span
              ><br /><br />
              <span>设备设施移交报告</span>
            </div>
            <div class="cover">
              <el-image class="proImg" :src="ProjectInfo.ProjectImg"></el-image>
              <div class="i-tit" style="margin-top: 100px">呈送：</div>
              <div class="i-tit">准备：铂诺客工程咨询（北京）有限公司</div>
              <div class="i-tit">
                日期：{{ moment().format('YYYY 年 MM 月 DD 日') }}
              </div>
            </div>
          </div>
          <div class="a1 w100" v-if="!ProjectInfoLoading">
            <!-- <div class="title">
              <span>{{ ProjectInfo.Name || '' }}</span
              ><br />
              <span>项目设备及资料移交报告</span>
            </div> -->
            <div style="height: 200px"></div>
            <div class="center-title">
              <div>
                <span class="label">项目地点：</span
                >{{ ProjectInfo.Province || '' }}{{ ProjectInfo.City || '' }}
              </div>
              <div>
                <span class="label">移交方：</span
                >铂诺客工程咨询（北京）有限公司
              </div>
              <div>
                <span class="label">接收方：</span
                >{{ ProjectInfo.Property_Company || '' }}
              </div>
              <div v-if="SupplierId">
                <span class="label">供应商：</span
                >{{
                  TaskSupplieData.find((item) => item.Id === SupplierId)
                    .cVenName || ''
                }}
              </div>
              <div>
                <span class="label">移交基准日：</span>
              </div>
              <div>
                <span class="label">报告编号：</span>
              </div>
            </div>
            <table border="1" class="table-html">
              <tr>
                <th style="line-height: 2.8">角色</th>
                <th style="line-height: 2.8">姓名</th>
                <th style="line-height: 2.8">职位</th>
                <th style="line-height: 2.8">签名</th>
                <th style="line-height: 2.8">日期</th>
              </tr>
              <tr v-for="item in a2TableData" :key="item.role">
                <td style="line-height: 2.8">{{ item.role }}</td>
                <td style="line-height: 2.8">&nbsp;</td>
                <td style="line-height: 2.8">&nbsp;</td>
                <td style="line-height: 2.8">&nbsp;</td>
                <td style="line-height: 2.8">&nbsp;</td>
              </tr>
            </table>
          </div>
          <el-skeleton :rows="18" animated v-if="ProjectInfoLoading" />
          <div class="a2">
            <div class="paragraph" v-if="!CumInfoLoading">
              <div class="paragraph-title">一、移交内容摘要</div>
              <div class="paragraph-text">
                本报告旨在正式确认，自&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;起，【{{
                  ProjectInfo.Name || ''
                }}】的合同约定设备、备品备件及相关技术资料已完成清点、测试与移交工作。主要内容概述如下：
              </div>
              <div class="paragraph-text">
                1.设备总量：共计移交
                {{ CumInfo.TotaDeviceQty || 0 }} 台/套主要设备。
              </div>
              <div class="paragraph-text">
                2.资料汇总：共接收供应商资质文件
                {{ CumInfo.TotalSupplierProjectTypeFilesQty || 0 }} 份，项目文件
                {{ CumInfo.TotalSupplierProjectFilesQty || 0 }} 份，设备技术手册
                {{ CumInfo.TotalDeviceDocSubQty || 0 }} 份。
              </div>
              <div class="paragraph-text">
                3.备件汇总：共接收各类备品备件
                {{ CumInfo.TotalDeviceAccessoryQty || 0 }} 件/套。
              </div>
              <div class="paragraph-text">
                4.结论：移交内容符合合同要求，接收方同意接收。
              </div>
            </div>
            <el-skeleton :rows="18" animated v-if="CumInfoLoading" />
            <div class="paragraph">
              <div class="paragraph-title" v-if="!CumInfoLoading">
                二、详细移交清单
              </div>
              <div class="w100" v-if="!DeviceDataLoading">
                <div class="paragraph-text">
                  2.1 按专业系统划分的设备移交统计
                </div>
                <table
                  border="1"
                  class="table-html dev"
                  style="margin-bottom: 50px"
                >
                  <tr>
                    <th style="width: 30px; flex: none">序号</th>
                    <th>设备分类</th>
                    <th>设备名称</th>
                    <th style="width: 100px; flex: none">移交数量</th>

                    <th style="width: 30px; flex: none">单位</th>
                    <th>供应商名称</th>
                    <th>安装区域</th>
                  </tr>
                  <tr
                    v-for="(item, index) in DeviceData"
                    :key="item.Id"
                    :class="item.Leve == 1 ? 'level1' : ''"
                  >
                    <td style="width: 30px; flex: none">{{ index + 1 }}</td>
                    <td style="justify-content: left">
                      {{ item.DeviceTypeName || '' }}
                    </td>
                    <td style="justify-content: left">
                      {{ item.device_name || '' }}
                    </td>
                    <td
                      style="
                        justify-content: right;
                        width: 100px;
                        flex: none;
                        padding: 0 10px;
                      "
                    >
                      {{ item.Num || '' }}
                    </td>
                    <td
                      style="width: 30px; flex: none; justify-content: center"
                    >
                      {{ '台' }}
                    </td>
                    <td style="justify-content: left">
                      {{ item.SupplierName || '' }}
                    </td>
                    <td style="justify-content: left">
                      {{ item.InstallationAreaName || '' }}
                    </td>
                  </tr>
                </table>
              </div>
              <el-skeleton :rows="18" animated v-if="DeviceDataLoading" />
              <div class="w100" v-if="!BuildingDataLoading">
                <div class="paragraph-text">2.2 按楼栋划分的设备移交统计</div>
                <table
                  border="1"
                  class="table-html dev"
                  style="margin-bottom: 50px"
                >
                  <tr>
                    <th
                      v-for="(item, index) in BuildingData.Columns"
                      :key="item.prop"
                      :style="index == 0 ? 'width: 30px; flex: none' : ''"
                    >
                      {{ item.label }}
                    </th>
                  </tr>
                  <tr
                    v-for="(val, inn) in BuildingData.Data"
                    :key="JSON.stringify(val)"
                  >
                    <td
                      v-for="(item, index) in BuildingData.Columns"
                      :key="item.prop + index"
                      :style="`${
                        index == 0 ? 'width: 30px; flex: none;' : ''
                      }justify-content: ${item.align};`"
                    >
                      {{ val[item.prop] }}
                    </td>
                  </tr>
                </table>
              </div>
              <el-skeleton :rows="18" animated v-if="BuildingDataLoading" />
              <div class="w100" v-if="!SupplieDataLoading">
                <div class="paragraph-text">2.3 按供应商划分的设备移交统计</div>
                <table
                  border="1"
                  class="table-html dev"
                  style="margin-bottom: 50px"
                >
                  <tr>
                    <th style="width: 30px; flex: none">序号</th>
                    <th>供应商名称</th>
                    <th>供应设备分类</th>
                    <th style="width: 30px; flex: none">单位</th>
                    <th style="width: 100px; flex: none">移交数量</th>

                    <th>联系人及电话</th>
                  </tr>
                  <tr v-for="(item, index) in SupplieData" :key="item.Id">
                    <td style="width: 30px; flex: none">
                      {{ index + 1 }}
                    </td>
                    <td style="justify-content: left">
                      {{ item.SupplierName || '' }}
                    </td>
                    <td style="justify-content: left">
                      {{ item.DeviceTypeName || '' }}
                    </td>

                    <td
                      style="width: 30px; flex: none; justify-content: center"
                    >
                      {{ '台' }}
                    </td>
                    <td
                      style="justify-content: right; width: 100px; flex: none"
                    >
                      {{ item.Num || '' }}
                    </td>
                    <td style="justify-content: left">
                      {{ item.manufacturer || '' }}
                    </td>
                  </tr>
                </table>
              </div>
              <el-skeleton :rows="18" animated v-if="SupplieDataLoading" />
            </div>

            <div class="paragraph">
              <div
                class="paragraph-title"
                v-if="
                  !DeviceDataLoading &&
                  !BuildingDataLoading &&
                  !SupplieDataLoading
                "
              >
                三、技术资料移交清单
              </div>
              <div class="w100" v-if="!SupplieFileLoading">
                <div class="paragraph-text">3.1 供应商资质文件</div>
                <div class="paragraph-text2">
                  ● 共接收 {{ SupplieFile.total || '0' }} 家供应商的资质文件
                </div>
                <div class="paragraph-text2">● 清单明细：</div>
                <table
                  border="1"
                  class="table-html"
                  style="margin-bottom: 50px"
                >
                  <tr>
                    <th
                      v-for="(item, index) in SupplieFile.Columns"
                      :key="item.prop"
                      :style="index == 0 ? 'width: 30px; flex: none' : ''"
                    >
                      {{ item.label }}
                    </th>
                  </tr>
                  <tr
                    v-for="val in SupplieFile.Data"
                    :key="JSON.stringify(val)"
                  >
                    <td
                      v-for="(item, index) in SupplieFile.Columns"
                      :key="item.prop + index"
                      :style="`${
                        index == 0 ? 'width: 30px; flex: none;' : ''
                      }justify-content: ${item.align};`"
                    >
                      <span v-if="index == 0 || index == 1">{{
                        val[item.prop]
                      }}</span>
                      <span v-else>
                        {{ val[item.prop] == 1 ? '有' : '' }}
                      </span>
                    </td>
                  </tr>
                </table>
              </div>
              <el-skeleton :rows="18" animated v-if="SupplieFileLoading" />
              <div class="w100" v-if="!ProjectDocLoading">
                <div class="paragraph-text">3.2 项目过程文件</div>
                <div class="paragraph-text2">
                  ● 共接收 {{ ProjectDoc.total || '0' }} 套项目过程文件
                </div>
                <div class="paragraph-text2">● 清单明细：</div>
                <table
                  border="1"
                  class="table-html"
                  style="margin-bottom: 50px"
                >
                  <tr>
                    <th style="width: 30px; flex: none">序号</th>
                    <th>文件类型</th>
                    <th>份数/套数</th>
                  </tr>
                  <tr
                    v-for="(val, index) in ProjectDoc.Data"
                    :key="JSON.stringify(val)"
                  >
                    <td style="width: 30px; flex: none">
                      {{ index + 1 }}
                    </td>
                    <td style="justify-content: center">
                      {{ val.name || '' }}
                    </td>
                    <td style="justify-content: center">
                      {{ val.value || '' }}
                    </td>
                  </tr>
                </table>
              </div>
              <el-skeleton :rows="18" animated v-if="ProjectDocLoading" />
              <div class="w100" v-if="!DeviceDocLoading">
                <div class="paragraph-text">3.3 设备技术资料</div>
                <div class="paragraph-text2">
                  ● 共接收 {{ DeviceDoc.total || '0' }} 本/套设备技术手册及说明
                </div>
                <div class="paragraph-text2">● 清单明细：</div>
                <table
                  border="1"
                  class="table-html"
                  style="margin-bottom: 50px"
                >
                  <tr>
                    <th
                      v-for="(item, index) in DeviceDoc.Columns"
                      :key="item.prop"
                      :style="index == 0 ? 'width: 30px; flex: none' : ``"
                    >
                      {{ item.label }}
                    </th>
                  </tr>
                  <tr v-for="val in DeviceDoc.Data" :key="JSON.stringify(val)">
                    <td
                      v-for="(item, index) in DeviceDoc.Columns"
                      :key="item.prop + index"
                      :style="`${
                        index == 0 ? 'width: 30px; flex: none;' : ''
                      }justify-content: ${item.align};`"
                    >
                      <span v-if="index == 0 || index == 1">{{
                        val[item.prop]
                      }}</span>
                      <span v-else>
                        {{ val[item.prop] == 1 ? '有' : '' }}
                      </span>
                    </td>
                  </tr>
                </table>
              </div>
              <el-skeleton :rows="18" animated v-if="DeviceDocLoading" />
            </div>
            <div class="paragraph" v-if="!DeviceAccessoryLoading">
              <div class="paragraph-title">四、备品备件移交清单</div>
              <table border="1" class="table-html" style="margin-bottom: 50px">
                <tr>
                  <th style="width: 30px; flex: none">序号</th>
                  <th>备件名称</th>
                  <th>对应设备</th>
                  <th style="width: 80px; flex: none">备件类型</th>
                  <th>规格型号</th>
                  <th>数量</th>
                </tr>
                <tr
                  v-for="(item, index) in DeviceAccessory.Data"
                  :key="JSON.stringify(item)"
                >
                  <td style="width: 30px; flex: none">{{ index + 1 }}</td>
                  <td style="justify-content: left">
                    {{ item.AccessoryName || '' }}
                  </td>
                  <td style="justify-content: left">
                    {{ item.DeviceName || '' }}
                  </td>
                  <td style="width: 80px; flex: none; justify-content: center">
                    {{ item.TypeName || '' }}
                  </td>
                  <td style="justify-content: left">
                    {{ item.AccessorySpec || '' }}
                  </td>
                  <td style="justify-content: right">
                    {{ item.AccessoryNum || '' }}
                  </td>
                </tr>
              </table>
            </div>
            <div class="paragraph" v-if="!DeviceAccessoryLoading">
              <div class="paragraph-title">五、移交结论</div>
              <div class="paragraph-text">
                经双方共同清点与确认，本次移交工作已基本完成。接收方对上述移交的设备、资料及备件状态予以确认（除第七部分所列遗留事项外）。自本报告签署之日起，上述资产的管理、使用及维护责任正式转移至接收方。
              </div>
            </div>
            <div
              class="paragraph"
              v-if="!DeviceAccessoryLoading"
              style="margin-top: 100px"
            >
              <div class="signInfo">
                <div class="left">
                  <div>移交方：（盖章）</div>
                  <div>代表：</div>
                  <div>日期：</div>
                </div>
                <div class="right">
                  <div>接收方：（盖章）</div>
                  <div>代表：</div>
                  <div>日期：</div>
                </div>
              </div>
            </div>
            <el-skeleton :rows="38" animated v-if="DeviceAccessoryLoading" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Loading } from 'element-ui'
import moment from 'moment'
export default {
  data() {
    return {
      moment,
      ProjectInfoLoading: true,
      ProjectInfo: {},
      printobj: {
        id: 'print-info',
      },
      CumInfoLoading: true,
      CumInfo: {},
      a2TableData: [
        {
          role: '移交方代表',
        },
        {
          role: '接收方代表',
        },
        {
          role: '监理方代表',
        },
        {
          role: '业主方代表',
        },
      ],
      DeviceDataLoading: true,
      DeviceData: [],
      BuildingDataLoading: true,
      BuildingData: {},
      SupplieDataLoading: true,
      SupplieData: [],
      SupplieFile: {},
      SupplieFileLoading: true,
      ProjectDoc: {},
      ProjectDocLoading: true,
      DeviceDoc: true,
      DeviceDocLoading: true,
      DeviceAccessory: [],
      DeviceAccessoryLoading: true,
      TaskSupplieData: [],
      SupplierId: '',
      // 防抖相关
      debounceTimer: null,
      debounceDelay: 300,
    }
  },
  props: {
    pId: {
      type: String,
      default: '',
    },
    taskId: {
      type: String,
      default: '',
    },
    isShowLeft: {
      type: Boolean,
      default: false,
    },
    isShowBut: {
      type: Boolean,
      default: true,
    },
    isShowClose: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  methods: {
    handleClick(item) {
      // 防抖处理，避免频繁点击触发多次请求
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
      }

      this.debounceTimer = setTimeout(() => {
        this.SupplierId = item.Id
        this.getDataList()
        this.debounceTimer = null
      }, this.debounceDelay)
    },
    close() {
      this.$emit('close')
    },
    //完成移交
    SubProjectInspect() {
      let loadingInstance = Loading.service({
        fullscreen: true,
        lock: true,
        text: '移交完成中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })

      this.$http
        .post(
          `/Base_ProjectWork/project_taskhandover/CompleteTaskhandoverData?&TaskId=${this.taskId}`,
          {}
        )
        .then((res) => {
          loadingInstance.close()
          if (res.Success) {
            this.$notify.success('操作成功！该任务已开始移交')
            this.$emit('successSub')
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    successSub() {
      this.$confirm('确认完结当前项目吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let loadingInstance = Loading.service({
          fullscreen: true,
          lock: true,
          text: '完结检查中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })

        this.$http
          .post(`/Base_ProjectWork/Base_Project/ProjectClosing`, {
            id: this.pId,
          })
          .then((res) => {
            loadingInstance.close()
            if (res.Success) {
              this.$notify.success('操作成功！项目已完结')
              this.$emit('successSub')
            } else {
              this.$notify.error(res.Msg)
            }
          })
      })
    },
    async getDeviceAccessory() {
      this.DeviceAccessoryLoading = true
      await this.$http
        .post(`/Base_ProjectWork/Base_Project/GetDeviceAccessoryList`, {
          Search: {
            ProjectId: this.pId,
            TaskId: this.taskId,
            SupplierId: this.SupplierId,
          },
        })
        .then((res) => {
          this.DeviceAccessoryLoading = false
          if (res.Success) {
            this.DeviceAccessory = res.Data || []
          } else {
            this.$notify.error(res.Msg)
          }
        })
        .catch(() => {
          this.DeviceAccessoryLoading = false
        })
    },
    async getTaskSupplieData() {
      await this.$http
        .post(
          `/Base_ProjectWork/project_taskhandover/GetTaskSupplierList?ProjectId=${this.pId}&TaskId=${this.taskId}`
        )
        .then((res) => {
          if (res.Success) {
            this.TaskSupplieData = res.Data || []
            if (this.isShowLeft) {
              this.SupplierId = this.TaskSupplieData[0]?.Id || ''
            } else {
              this.SupplierId = ''
            }
          } else {
            this.$message.error(res.Msg)
          }
        })
    },
    async getDeviceDoc() {
      this.DeviceDocLoading = true
      await this.$http
        .post(
          `/Base_ProjectWork/Base_Project/GetProjectDeviceDocStatistics?ProjectId=${this.pId}&TaskId=${this.taskId}&SupplierId=${this.SupplierId}`,
          {}
        )
        .then((res) => {
          this.DeviceDocLoading = false
          if (res.Success) {
            this.DeviceDoc = res.Data || []
          } else {
            this.$notify.error(res.Msg)
          }
        })
        .catch(() => {
          this.DeviceDocLoading = false
        })
    },
    async getProjectDoc() {
      this.ProjectDocLoading = true
      await this.$http
        .post(
          `/Base_ProjectWork/Base_Project/GetProjectDocStatistics?ProjectId=${this.pId}&TaskId=${this.taskId}&SupplierId=${this.SupplierId}`,
          {}
        )
        .then((res) => {
          this.ProjectDocLoading = false
          if (res.Success) {
            this.ProjectDoc = res.Data || []
          } else {
            this.$notify.error(res.Msg)
          }
        })
        .catch(() => {
          this.ProjectDocLoading = false
        })
    },
    async getSupplieFile() {
      this.SupplieFileLoading = true
      await this.$http
        .post(
          `/Base_ProjectWork/Base_Project/GetProjectQualificationDocStatistics?ProjectId=${this.pId}&TaskId=${this.taskId}&SupplierId=${this.SupplierId}`,
          {}
        )
        .then((res) => {
          this.SupplieFileLoading = false
          if (res.Success) {
            this.SupplieFile = res.Data || []
          } else {
            this.$notify.error(res.Msg)
          }
        })
        .catch(() => {
          this.SupplieFileLoading = false
        })
    },
    async getSupplieData() {
      this.SupplieDataLoading = true
      await this.$http
        .post(
          `/Base_ProjectWork/Base_Project/GetProjectSupplierDeviceStatisticsList`,
          {
            ProjectId: this.pId,
            TaskId: this.taskId,
            SupplierId: this.SupplierId,
          }
        )
        .then((res) => {
          this.SupplieDataLoading = false
          if (res.Success) {
            this.SupplieData = res.Data || []
          } else {
            this.$notify.error(res.Msg)
          }
        })
        .catch(() => {
          this.SupplieDataLoading = false
        })
    },
    async getBuildingData() {
      this.BuildingDataLoading = true
      await this.$http
        .post(
          `/Base_ProjectWork/Base_Project/GetDeviceTypeBuildingStatistics?ProjectId=${this.pId}&TaskId=${this.taskId}&SupplierId=${this.SupplierId}`,
          {}
        )
        .then((res) => {
          this.BuildingDataLoading = false
          if (res.Success) {
            this.BuildingData = res.Data || {}
          } else {
            this.$notify.error(res.Msg)
          }
        })
        .catch(() => {
          this.BuildingDataLoading = false
        })
    },
    async getDeviceData() {
      this.DeviceDataLoading = true
      await this.$http
        .post(`/Base_ProjectWork/Base_Project/GetProjectDeviceStatisticsList`, {
          ProjectId: this.pId,
          TaskId: this.taskId,
          SupplierId: this.SupplierId,
        })
        .then((res) => {
          this.DeviceDataLoading = false
          if (res.Success) {
            this.DeviceData = res.Data || []
          } else {
            this.$notify.error(res.Msg)
          }
        })
        .catch(() => {
          this.DeviceDataLoading = false
        })
    },

    async getcumInfo() {
      this.CumInfoLoading = true
      await this.$http
        .post(
          `/Base_ProjectWork/Base_Project/GetProjectStatics?ProjectId=${this.pId}&TaskId=${this.taskId}&SupplierId=${this.SupplierId}`,
          {}
        )
        .then((res) => {
          this.CumInfoLoading = false
          if (res.Success) {
            this.CumInfo = res.Data || {}
          } else {
            this.$notify.error(res.Msg)
          }
        })
        .catch(() => {
          this.CumInfoLoading = false
        })
    },
    async getInfo() {
      this.ProjectInfoLoading = true
      await this.$http
        .post('/Base_ProjectWork/Base_Project/GetTheData', {
          id: this.pId,
        })
        .then((res) => {
          this.ProjectInfoLoading = false
          if (res.Success) {
            this.ProjectInfo = res.Data || {}
          }
        })
        .catch(() => {
          this.ProjectInfoLoading = false
        })
    },

    printDom() {
      this.$nextTick(() => {
        let dom = document.getElementById('print-info')
        this.$print(dom)
      })
    },
    async getDataList() {
      this.CumInfoLoading = true
      this.DeviceDataLoading = true
      this.BuildingDataLoading = true
      this.SupplieDataLoading = true
      this.SupplieFileLoading = true
      this.ProjectDocLoading = true
      this.DeviceDocLoading = true
      this.DeviceAccessoryLoading = true

      await this.getcumInfo()
      await this.getDeviceData()
      await this.getBuildingData()
      await this.getSupplieData()
      await this.getSupplieFile()
      await this.getProjectDoc()
      await this.getDeviceDoc()
      this.getDeviceAccessory()
    },
  },
  mounted() {},
  async created() {
    await this.getTaskSupplieData()
    await this.getInfo()
    await this.getDataList()
  },
  beforeDestroy() {
    // 清理防抖定时器，避免内存泄漏
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = null
    }
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
.top-title {
  padding: 0 20px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.content-info {
  height: calc(100% - 50px);
  overflow-y: auto;
  color: #000000;
  font-size: 14px;
  padding: 10px;
  position: relative;
}
.left-info {
  width: calc(15% - 20px);
  height: 80vh;
  position: fixed;
  top: 10vh;
  left: 0;
  z-index: 99;
  .box-card {
    width: 100%;
    height: 100%;
    ::v-deep .el-card__body {
      height: 100%;
      padding: 10px;
      overflow-y: auto;
    }
  }
  .supplier-title {
    font-size: 16px;
    font-weight: bold;
    padding: 10px;
    margin-bottom: 10px;
  }
  .supplier-item {
    padding: 10px;
    font-size: 14px;
    margin-bottom: 10px;
    cursor: pointer;
    border-radius: 4px;
    transition: all 0.3s ease;

    &:hover {
      background-color: #f5f7fa;
      transform: translateX(5px);
    }

    &.active {
      background-color: #ecf5ff;
      border-left: 3px solid #409eff;
      transform: translateX(5px);
    }

    ::v-deep .el-button {
      width: 100%;
      text-align: left;
      border: none;
      background-color: transparent;

      &:focus,
      &:hover {
        background-color: transparent;
        border-color: transparent;
      }

      &.el-button--primary {
        background-color: transparent;
        color: #409eff;
        font-weight: bold;
      }
    }
  }
}
.content {
  width: 70%;
  max-width: 1000px;
  margin: 0 auto;

  // border: 1px solid #ccc;
}
.a1 {
  line-height: 1.5;
  page-break-after: always;
  margin-bottom: 50px;

  padding-top: 100px;
  .title {
    font-size: 26px;
    width: 500px;
    margin-left: 400px;
    font-weight: bold;

    color: #000000;
    text-align: right;
  }
  .center-title {
    font-size: 16px;
    color: #000000;
    line-height: 2.2;
  }
  .label {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
}
.cover {
  width: 100%;
  margin: 0 auto;
  .proImg {
    width: 500px;
    height: 400px;
    margin-top: 100px;
    margin-bottom: 100px;
    margin-left: 400px;
  }
  .i-tit {
    width: 500px;

    font-size: 18px;
    margin: 30px auto;
    margin-left: 400px;
  }
}
.a2 {
}
.paragraph {
  width: 100%;
  margin-bottom: 50px;
}
.table-html {
  margin-top: 20px;
  width: 100%;
  line-height: 40px;
  border: 1px solid #000000; /* 设置边框样式 */
  border-collapse: collapse; /* 合并边框，使边框看起来更一致 */
  color: #000000;
  th,
  td {
    overflow: hidden;
    padding: 0 3px;

    border: 1px solid #000000; /* 设置边框样式 */
    border-collapse: collapse; /* 合并边框，使边框看起来更一致 */
    box-sizing: border-box;
  }
  tr {
    display: flex;
    width: 100%;
    th,
    td {
      overflow: hidden;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 3px;
      line-height: 1.5;
      box-sizing: border-box;
    }
  }
}

.level1 {
  font-size: 16px;
  color: #000;
  font-weight: bold;
}
.paragraph-title {
  font-size: 16px;
  font-weight: bold;
}
.paragraph-text {
  text-indent: 30px;
}
.paragraph-text2 {
  text-indent: 55px;
}
.signInfo {
  display: flex;
  gap: 20px;
  .left {
    width: 40%;
    margin-left: 5%;
    line-height: 2.8;
  }
  .right {
    width: 40%;
    margin-left: 10%;
    line-height: 2.8;
  }
}
::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
  border-color: #000000;
}
::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  border-color: #000000;
}
::v-deep .el-checkbox {
  margin-right: 3px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}
::v-deep .el-checkbox__label {
  padding-left: 2px;
}

@page {
  size: auto;
  margin: 10mm !important;
}

@media print {
  * {
    -webkit-print-color-adjust: exact !important;
    -moz-print-color-adjust: exact !important;
    -ms-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
}
</style>
